export const FTP_POLLERS_ORDER_BY = [
  'last_successful_run',
  'problem_present_since',
  'consecutive_errors',
  'last_run',
  // Kept for URLs created before DNI-804 replaced this legacy field in the UI.
  'last_received_on',
  'modified_on',
] as const;
